import React, { useEffect, useState } from 'react';
import { Fab, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const GoToTopButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) setShow(true);
      else setShow(false);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Zoom in={show}>
      <Fab
        onClick={scrollTop}
        size="medium"
        sx={{
          position: 'fixed',
          bottom: 60,
          right: 30,
          zIndex: 2000,
          background: 'linear-gradient(135deg,#2E7D32,#4CAF50)',
          color: '#fff',
          boxShadow: '0 12px 30px rgba(0,0,0,0.25)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px) scale(1.05)',
            boxShadow: '0 18px 40px rgba(0,0,0,0.35)',
            background: 'linear-gradient(135deg,#1B5E20,#43A047)',
          },
        }}
      >
        <KeyboardArrowUpIcon fontSize="large" />
      </Fab>
    </Zoom>
  );
};

export default GoToTopButton;
